<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM7.25 3V8.36035L7.53125 8.58594L10.0312 10.5859L10.6172 11.0537L11.5537 9.88281L10.9688 9.41406L8.75 7.63867V3H7.25Z"
    fill="currentColor"
  />
</svg>
